import { Component, OnInit } from '@angular/core';
import {DiamondPayDataService} from "../diamond-pay-data-service.service";

@Component({
  selector: 'single-transactions',
  templateUrl: './single-transactions.component.html',
  styleUrls: ['./single-transactions.component.css'],
  providers: [DiamondPayDataService],
})
export class SingleTransactionsComponent implements OnInit {
  public collection: any[];

  constructor(private _dataService: DiamondPayDataService) { }

  ngOnInit() {
    this._dataService
            .RetrieveDiamondCoreInitiatedTransactions()
            .subscribe((data:any[]) => this.collection = data, error => console.log(error));
  }

}



// WEBPACK FOOTER //
// ./src/app/single-transactions/single-transactions.component.ts